import { render, staticRenderFns } from "./AssignZoneGroupsModal.vue?vue&type=template&id=b20984d0&scoped=true&"
import script from "./AssignZoneGroupsModal.vue?vue&type=script&lang=ts&"
export * from "./AssignZoneGroupsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssignZoneGroupsModal.vue?vue&type=style&index=0&id=b20984d0&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20984d0",
  null
  
)

export default component.exports